export default {
    "mitacVideo_error": "Error connecting to the live stream, please try again.",
    "mitacVideo_deviceOffline": "The device is currently offline - unable to live stream",
}
